import { assert } from '@ember/debug';
import { action } from '@ember/object';
import TippyDropdown from 'scaleflow/components/dropdowns/tippy-dropdown';

export default class InitiativesTableHeaderFilterDropdownComponent extends TippyDropdown {
  get ComponentName() {
    return this.args.tippy ? 'Tippy' : 'empty-component';
  }

  @action
  onGroupingSelect() {
    if (!this.args?.onGroupingSelect)
      assert(
        'Please pass a "onGroupingSelect" callback to InitiativesTableHeaderFilterDropdownComponent',
      );
    this.args.onGroupingSelect({ value: this.args.groupingKey });
  }

  get tableSelector() {
    if (this.args.tableSelector)
      return document.querySelector(this.args.tableSelector);
    return document.querySelector('#initiatives-table');
  }

  @action
  onSortSelect(...args) {
    if (!this.args?.onSort)
      assert(
        'Please pass a "onSort" callback to InitiativesTableHeaderFilterDropdownComponent',
      );
    this.args.onSort(...args);
  }

  @action
  onHideColumn() {
    this.args?.onHideColumn();
  }
}
